<template>
  <BaseFetchData :action="fetchActivityLogs">
    <!-- props
      fetchData, status.loading, status.resolved, status.rejected, rejectReason
    -->
    <template #default="fetchDataProps">
      <BaseCard v-if="fetchDataProps.status.resolved" class="max-w-xl mx-auto">
        <BaseCardBody>
          <ul role="list" class="divide-y -my-2">
            <ActivityLogListItem
              v-for="activityLog in activityLogData.data"
              :activity-log="activityLog"
              :key="activityLog.id"
            />
          </ul>
          <div v-if="hasOlder || hasNewer" class="flex space-x-2 justify-center mt-6">
            <BaseButton v-if="hasNewer" small primary outline>Newer</BaseButton>
            <BaseButton v-if="hasOlder" small primary outline>Older</BaseButton>
          </div>
        </BaseCardBody>
      </BaseCard>
    </template>
  </BaseFetchData>
</template>

<script>
import { contactActivityLogsClient } from '@/api/clients';
import ActivityLogListItem from './ActivityLogListItem.vue';

export default {
  components: {
    ActivityLogListItem,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activityLogData: null,
    };
  },
  computed: {
    currentPage() {
      return this.activityLogData?.meta?.current_page || 1;
    },
    lastPage() {
      return this.activityLogData?.meta?.last_page || 1;
    },
    hasOlder() {
      return this.currentPage < this.lastPage;
    },
    hasNewer() {
      return this.currentPage > 1;
    },
  },
  methods: {
    async fetchActivityLogs() {
      try {
        this.activityLogData = await contactActivityLogsClient.list(this.contactId, {
          include: 'causer',
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
